import { useState, useEffect } from 'react';
import * as api from '../lib/api';

// null while loading (so screens don't flash the wrong state), then true/false.
// A failed request counts as off, matching the server's default.
export const useLibraryEnabled = () => {
  const [enabled, setEnabled] = useState(null);

  useEffect(() => {
    let active = true;
    api.getLibrarySetting()
      .then((res) => { if (active) setEnabled(!!res.data?.enabled); })
      .catch(() => { if (active) setEnabled(false); });
    return () => { active = false; };
  }, []);

  return enabled;
};
